import { ValidationResults } from '@ag-common-lib/lib';
import { Address, AddressModelKeys } from '@ag-common-lib/public-api.functions';
import * as uuid from 'uuid';

export const getAddressKeyExpression = (address: Address) => {
  if (!address) {
    return null;
  }
  const keyItems = [
    address?.address1,
    address?.address2,
    address?.city,
    // address?.state,
    // address?.zip,
    // address?.country,
    // address?.county,
  ];

  if (!keyItems.some(Boolean)) {
    return null;
  }

  return keyItems.join(',');
};

export const normalizeAddresses = (addressToEdit: Address, addresses: Address[]) => {
  if (!addressToEdit) {
    return addresses;
  }

  const hasPrimaryBillingAddresses =
    !!addresses?.length && addresses?.some(address => address?.[AddressModelKeys.isPrimaryBilling]);
  const hasPrimaryShippingAddresses =
    !!addresses?.length && addresses?.some(address => address?.[AddressModelKeys.isPrimaryShipping]);

  if (!hasPrimaryBillingAddresses) {
    addressToEdit[AddressModelKeys.isPrimaryBilling] = true;
  }
  if (!hasPrimaryShippingAddresses) {
    addressToEdit[AddressModelKeys.isPrimaryShipping] = true;
  }

  const isPrimaryBilling = addressToEdit?.[AddressModelKeys.isPrimaryBilling];
  const isPrimaryShipping = addressToEdit?.[AddressModelKeys.isPrimaryShipping];
  const isPhysicalLocation = addressToEdit?.[AddressModelKeys.isPhysicalLocation];

  let isUpdated = false;

  const normalizedAddresses = addresses.map(address => {
    if (addressToEdit?.[AddressModelKeys.id] === address?.[AddressModelKeys.id]) {
      isUpdated = true;
      return addressToEdit;
    }

    const normalizedAddress = Object.assign({}, address);
    if (isPrimaryBilling) {
      Object.assign(normalizedAddress, { [AddressModelKeys.isPrimaryBilling]: false });
    }
    if (isPrimaryShipping) {
      Object.assign(normalizedAddress, { [AddressModelKeys.isPrimaryShipping]: false });
    }
    if (isPhysicalLocation) {
      Object.assign(normalizedAddress, { [AddressModelKeys.isPhysicalLocation]: false });
    }

    return normalizedAddress;
  });

  if (!isUpdated) {
    normalizedAddresses.push(Object.assign({}, addressToEdit));
  }

  return normalizedAddresses;
};

export const normalizeAddressesFromFirestore = (addresses: Address[]) => {
  if (!addresses?.length) {
    return [];
  }
  const idsSet = new Set();

  const normalizedAddresses = addresses?.map(address => {
    const normalizedAddress = Object.assign({}, new Address(), address);
    let addressId = normalizedAddress?.[AddressModelKeys.id];

    if (!addressId || idsSet.has(addressId)) {
      addressId = uuid.v4();
      normalizedAddress[AddressModelKeys.id] = addressId;
    }

    idsSet.add(addressId);

    return normalizedAddress;
  });

  return normalizedAddresses;
};

export enum AddressValidationStatus {
  valid = 'valid',
  warning = 'warning',
  invalid = 'invalid',
}
export function checkAddressValidationStatus(validationResults: ValidationResults) {
  const verdict = validationResults?.verdict;
  const address = validationResults?.address;
  const unconfirmedComponentTypes = address?.unconfirmedComponentTypes;

  if (!verdict) {
    return AddressValidationStatus.invalid;
  }

  const hasAddress1UnconfirmedParts = unconfirmedComponentTypes?.some(type => {
    return new Set([
      'street_address',
      'route',
      'intersection',
      'premise',
      /* 'street_number', */ 'point_of_interest',
    ]).has(type);
  });

  if (hasAddress1UnconfirmedParts) {
    return AddressValidationStatus.invalid;
  }

  if (!!verdict?.addressComplete && !verdict?.hasUnconfirmedComponents) {
    return AddressValidationStatus.valid;
  }

  return AddressValidationStatus.warning;
}
